import logout from "../../assets/gif/logout.gif";
import Modal from "../Modal/Modal";

const LogoutConfirmationModal = ({
  showModal,
  onClose,
  handleLogout,
  disable = false,
}) => {
  return (
    <Modal width="450px" show={showModal} onClose={onClose}>
      <form className="py-3 text-center">
        <div className="flex justify-center mt-[-20px]">
          <img src={logout} alt="logout img" height={120} width={120} />
        </div>

        <div className="flex-1 mt-4 text-center w-30">
          <p className="head-1 dark-H font-bold">
            Logout Confirmation
          </p>

          <p className="py-1 dark-M body-L">
            Are you sure you want to log out of your account?
          </p>
        </div>

        <div className="mt-6 flex justify-center">
          <button
            type="button"
            disabled={disable}
            style={{
              opacity: disable ? 0.5 : 1,
              cursor: disable ? "not-allowed" : ""
            }}
            onClick={handleLogout}
            className="save-button light-L head-5 red-bg-D px-[30px] py-[12px]"
          >
            Logout
          </button>

          <button type="button" onClick={onClose} className="green-H body-N ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default LogoutConfirmationModal;
